import { GET_FOUNDERS_START } from '../../types';

export const get_founders = (payload) => ({
  type: GET_FOUNDERS_START,
  payload,
});
